export default "__VITE_ASSET__ws4fqyUG__"